import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import NavRight from "./NavRight";
import marutilogo from "../../../assets/images/marutilogo/marutiHeader.svg";
import portalImage from "../../../assets/images/marutilogo/portalImage.png";
import { ConfigContext } from "../../../contexts/ConfigContext";
import * as actionType from "../../../store/actions";
import useAuth from "../../../hooks/useAuth";
import { getRoleName } from "../../../config/constant";

const NavBar = () => {
  const configContext = useContext(ConfigContext);
  const {
    collapseMenu,
    headerBackColor,
    headerFixedLayout,
    layout,
    subLayout,
  } = configContext.state;
  const { dispatch } = configContext;
  const { user } = useAuth();
  const [userName, setUsername] = useState(user?.username || "");
  const getUserName = (userName) => {
    setUsername(userName);
  };
  let headerClass = [
    "navbar",
    "pcoded-header",
    "navbar-expand-lg",
    headerBackColor,
  ];
  if (headerFixedLayout && layout === "vertical") {
    headerClass = [...headerClass, "headerpos-fixed"];
  }

  let toggleClass = ["mobile-menu"];
  if (collapseMenu) {
    toggleClass = [...toggleClass, "on"];
  }

  const navToggleHandler = () => {
    dispatch({ type: actionType.COLLAPSE_MENU });
  };

  let collapseClass = ["collapse navbar-collapse"];
  let navBar = (
    <React.Fragment>
      <div className="m-header">
        <Link
          to="#"
          className={toggleClass.join(" ")}
          id="mobile-collapse"
          onClick={navToggleHandler}
        >
          <span />
        </Link>
        <Link to="#" className="b-brand">
          <div className="b-bg ml-3">
            <span className="b-title">
              <img className="b-image" src={marutilogo} alt="Maruti Logo" />
            </span>
          </div>
        </Link>
        {/* <Link to='#' className={moreClass.join(' ')} onClick={() => setMoreToggle(!moreToggle)}>
                    <i className="feather icon-more-vertical"/>
                </Link> */}
      </div>
      <div className="flex w-100">
        <span class="flex justify-center b-bg ml-3">
          <span className="b-title">
            <img
              className="b-image b-maruti-img"
              src={portalImage}
              alt="Maruti Logo"
            />
          </span>
        </span>

        <div className={collapseClass.join(" ")}>
          {/* <GlobalFilterGroup/> */}
          <h5 className="mb-0 ml-4">
            Welcome {getRoleName(Number(user.user_role))} ({userName})
          </h5>
          <NavRight getUserName={getUserName} />
        </div>
      </div>
    </React.Fragment>
  );

  if (layout === "horizontal" && subLayout === "horizontal-2") {
    navBar = <div className="container">{navBar}</div>;
  }

  return (
    <React.Fragment>
      <header className={headerClass.join(" ")}>{navBar}</header>
    </React.Fragment>
  );
};

export default NavBar;
